export default {
  lessThan25000: 'less_than_25000',
  between25000And49999: 'between_25000_and_49999',
  between50000And84999: 'between_50000_and_84,999',
  over85000: 'over_85000',
};
